import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material'

const CommonTable = ({ columns, data }) => {
  const classes = useStyles()
  if (!data?.length) return null

  return (
    <Table size='small' stickyHeader className={classes.tableContainer}>
      <TableHead>
        <TableRow>
          {columns?.map((col, index) => (
            <TableCell key={index} align='center'>
              <strong>{col?.label}</strong>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.map((row, rowIndex) => (
          <TableRow key={rowIndex} className={classes.tableRow}>
            {columns?.map((col, colIndex) => (
              <TableCell key={colIndex} align='center'>
                {col?.format ? col?.format(row[col?.field]) : row[col?.field]}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default CommonTable

const useStyles = makeStyles({
  tableContainer: {
    width: '100%',
    boxSizing: 'border-box',
    border: '1px solid lightgray',
    borderCollapse: 'unset',
    borderRadius: '10px',
    padding: '2px',
  },
  tableRow: {
    '&:last-child td': {
      borderBottom: 'none',
    },
  },
})
